module.exports = __webpack_public_path__ + "img/home_mobile.85f7f43e.jpg";